import React from 'react';
import { useTheme } from '../context/ThemeContext';
import '../styles/ThemeToggleButton.css';

export default function ThemeToggleButton() {
  const { theme, toggleTheme } = useTheme();

  return (
    <button
      type="button"
      className="theme-toggle-button"
      onClick={toggleTheme}
      aria-label={`테마 전환 (현재 ${theme === 'light' ? '라이트' : '다크'})`}
    >
      {theme === 'light' ? '🌙' : '☀️'}
    </button>
  );
}
